import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Button } from '@/ui/components/arandu/button';
import { Icon } from '@/ui/components/icon';
import { useSession } from '@/ui/hooks/use-session';

export const CreateEventNow = () => {
  const { session } = useSession();
  const nav = useNavigate();
  const { t } = useTranslation();

  return (
    <section className='w-full px-mini py-xxl md:py-huge relative'>
      <video
        className='absolute top-0 left-0 w-full h-full object-cover'
        src='https://joebfozvrfyvazbnvoxy.supabase.co/storage/v1/object/public/events/public/hero-background.webm'
        playsInline
        autoPlay
        muted
        loop
      />
      <div className='absolute inset-0 bg-base-neutral-black/[55%]' />
      <div className='size-full flex flex-col items-center gap-mini md:text-center relative z-10'>
        <h1 className='ts-heading-xl md:ts-heading-xxxl text-ctx-content-titleAlternative w-xxs md:w-auto mr-auto md:mr-none'>
          {t('linka-events')}
        </h1>
        <p className='ts-paragraph-sm text-ctx-content-titleAlternative'>{t('home.create-event-now.description')}</p>
        <Button
          trailingIcon={() => <Icon icon='arrow-up-right' />}
          hierarchy='primary'
          className='!bg-ctx-content-primaryAlternative !text-ctx-content-title !rounded-sm hover:opacity-semiOpaque !duration-500 ease-in-out mt-mini'
          onClick={() => nav(`${session ? '/events' : '/auth/login'}`)}
          size='lg'
        >
          {t('create-event-now')}
        </Button>
      </div>
    </section>
  );
};
